var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileSignal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6666 0.666626H15.6666C15.1143 0.666626 14.6666 1.11434 14.6666 1.66663V10.3333C14.6666 10.8856 15.1143 11.3333 15.6666 11.3333H16.6666C17.2189 11.3333 17.6666 10.8856 17.6666 10.3333V1.66663C17.6666 1.11434 17.2189 0.666626 16.6666 0.666626ZM11 2.99996H12C12.5522 2.99996 13 3.44767 13 3.99996V10.3333C13 10.8856 12.5522 11.3333 12 11.3333H11C10.4477 11.3333 9.99996 10.8856 9.99996 10.3333V3.99996C9.99996 3.44767 10.4477 2.99996 11 2.99996ZM7.33329 5.33329H6.33329C5.78101 5.33329 5.33329 5.78101 5.33329 6.33329V10.3333C5.33329 10.8856 5.78101 11.3333 6.33329 11.3333H7.33329C7.88558 11.3333 8.33329 10.8856 8.33329 10.3333V6.33329C8.33329 5.78101 7.88558 5.33329 7.33329 5.33329ZM2.66663 7.33329H1.66663C1.11434 7.33329 0.666626 7.78101 0.666626 8.33329V10.3333C0.666626 10.8856 1.11434 11.3333 1.66663 11.3333H2.66663C3.21891 11.3333 3.66663 10.8856 3.66663 10.3333V8.33329C3.66663 7.78101 3.21891 7.33329 2.66663 7.33329Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSignal);
export default __webpack_public_path__ + "static/media/mobile-signal.8cb5fac7cc6a4046192f6693e163aaa4.svg";
export { ForwardRef as ReactComponent };